export const CARD_HEADER_ICON = 'CARD_HEADER_ICON'
